import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { CCard, CCardBody, CCol, CRow, CProgress, CLabel, CTextarea, CButton, CImg } from 'compat/coreui'
import axios from 'axios';
import Rating from 'react-rating';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';


export default function Reviews(props) {
    const [review, setReview] = useState('');
    const [rating, setRating] = useState(0);
    const [value, setValue] = useState(0);
    const [voteCount, setVoteCount] = useState(0);
    const [show, setShow] = useState(false);
    const token = localStorage.getItem('token');
    const user = useSelector(state => state.user);

    const reviewHandler = () => {

        axios({
            url: `${process.env.REACT_APP_APP_API_URL}/api/review`,
            headers: {
                Authorization: `Bearer ${token}`
            },
            method: `GET`
        }).then(response => {
            console.log('review api response', response);
            if (response.data.status) {
                setReview(response.data.review);
            }
        }).catch(console.log)
    }

    useEffect(() => {
        reviewHandler()
    }, [])

    return (
        <div>
            <CCard className="business-dashboard">
                <CCardBody>
                    <CRow className="p-4">
                        <CCol xl={4}>
                            <div>
                                <div className="hexagon dash-hexagon"><span>{review.length} Reviews</span></div>
                            </div>
                        </CCol>

                    </CRow>

                    <CRow>
                        <CCol lg={12} className="review-headding"><h2>Reviews & Tips</h2></CCol>
                        <CCol xl={12}>
                            <table className="review-table">
                                <tbody>
                                    {review && review.map((reviewItem, i) => {
                                        const postTime = moment(reviewItem.createdAt, 'YYYY-MM-DD').format('DD-MM-YY');
                                        return (<tr key={i}>

                                            <td><CImg width="77%" src="/images/smoke1.png" className="rounded-circle" /></td>
                                            <td>
                                                <div>
                                                    <p>{reviewItem.msg}</p>
                                                    <span className="feature-text">Featured</span>
                                                    <span>{Array.apply(null, { length: reviewItem.rating }).map((i, index) => <CImg width="30" src="/images/11.png" key={index} />)}</span>
                                                    <span>Posted on {postTime}</span>
                                                </div>
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </div>
    )
}